"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AppPaySystemWalletsListCtl = /** @class */ (function (_super) {
    __extends(AppPaySystemWalletsListCtl, _super);
    function AppPaySystemWalletsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_wallet = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet; });
        _this.dk_pool_tag = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pool_tag; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_wallet_locks_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_locks_count; });
        _this.dk_wallet_crypto_currency_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_crypto_currency_code; });
        _this.dk_wallet_crypto_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_crypto_currency_title; });
        _this._errDialog = errDialog;
        return _this;
    }
    AppPaySystemWalletsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    AppPaySystemWalletsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    AppPaySystemWalletsListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListInnerPayWalletsGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    wallet: resp.list[i].wallet,
                    pool_tag: resp.list[i].pool_tag,
                    description: resp.list[i].description,
                    is_locked: resp.list[i].is_locked,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    wallet_crypto_currency_code: resp.list[i].wallet_crypto_currency_code,
                    wallet_crypto_currency_title: resp.list[i].wallet_crypto_currency_title,
                    wallet_locks_count: resp.list[i].wallet_locks_count
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AppPaySystemWalletsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddInnerPayWallet.exec({
            data: {
                wallet: data.wallet,
                pool_tag: data.pool_tag,
                is_locked: data.is_locked,
                description: data.description,
                wallet_crypto_currency_code: data.wallet_crypto_currency_code
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                wallet: data.wallet,
                pool_tag: data.pool_tag,
                is_locked: data.is_locked,
                description: data.description,
                wallet_crypto_currency_code: data.wallet_crypto_currency_code,
                wallet_crypto_currency_title: resp.wallet_crypto_currency_title,
                wallet_locks_count: 0
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AppPaySystemWalletsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditInnerPayWallet.exec({
                data: {
                    inner_pay_wallet_id: data.key,
                    wallet: data.wallet,
                    pool_tag: data.pool_tag,
                    is_locked: data.is_locked,
                    description: data.description,
                    wallet_crypto_currency_code: data.wallet_crypto_currency_code
                }
            }, function (resp) {
                _tmp.wallet = data.wallet;
                _tmp.pool_tag = data.pool_tag;
                _tmp.is_locked = data.is_locked;
                _tmp.description = data.description;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.wallet_crypto_currency_code = data.wallet_crypto_currency_code;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AppPaySystemWalletsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AppPaySystemWalletsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteInnerPayWallet.exec({ data: { inner_pay_wallet_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AppPaySystemWalletsListCtl.prototype.SetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetInnerPayWalletIsLocked.exec({ data: { inner_pay_wallet_id: key, is_locked: IsLocked } }, function (resp) {
                _tmp.is_locked = IsLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AppPaySystemWalletsListCtl;
}(BaseController_1.BaseController));
exports.AppPaySystemWalletsListCtl = AppPaySystemWalletsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_wallets/ctl/AppPsySystemWalletsListCtl.ts
// module id = 1054
// module chunks = 0